import { z } from 'zod';

export const currencySchema = z.enum([
  'AED',
  'AUD',
  'BRL',
  'CAD',
  'CHF',
  'COP',
  'EGP',
  'EUR',
  'GBP',
  'HKD',
  'ILS',
  'INR',
  'JPY',
  'KRW',
  'MAD',
  'MXN',
  'NZD',
  'QAR',
  'SAR',
  'SGD',
  'THB',
  'TWD',
  'USD',
  'ZAR',
]);

export type Currency = z.infer<typeof currencySchema>;
